export const setUSECASESOBJECT = "setUSECASESOBJECT";
